import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import SEO from './components/SEO';
import Cursor from './components/Cursor';
import Hero from './components/Hero';
import ImpactSnapshot from './components/ImpactSnapshot';
import WhyCorporates from './components/WhyCorporates';
import Services from './components/Services';
import Methodology from './components/Methodology';
import CaseStudies from './components/Testimonials';
import FaqContact from './components/FaqContact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import {
  IMPACT,
  SERVICE_CARDS,
  FULL_SUPPORT,
  METHODOLOGY,
  METHODOLOGY_BADGES,
  CASE_STUDIES,
  FAQS,
  SERVICE_OPTIONS,
} from './mock';

const Home = () => (
  <div className="App bg-radial-glow min-h-screen">
    <SEO />
    <Cursor />
    <Navbar />
    <main role="main">
      <Hero />
      <section aria-label="Impact snapshot and key outcomes">
        <ImpactSnapshot data={IMPACT} />
      </section>
      <WhyCorporates />
      <Services data={SERVICE_CARDS} fullSupport={FULL_SUPPORT} />
      <Methodology steps={METHODOLOGY} badges={METHODOLOGY_BADGES} />
      <CaseStudies data={CASE_STUDIES} />
      <FaqContact faqs={FAQS} serviceOptions={SERVICE_OPTIONS} />
    </main>
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
